// extracted by mini-css-extract-plugin
export default {"container":"SignIn_container__ohDgQ","welcome":"SignIn_welcome__ymyd2","link":"SignIn_link__XsWkA"};